<div *ngIf="showReset" class="row">
    <div class="text-danger text-center fw-bold">Bitte Eva-Reset durchführen, um die Änderungen wirksam zu machen
        <div class="d-flex justify-content-center align-content-center mb-2">
            <button class="btn btn-outline-danger rounded-0 mt-4 avs-test-area-save-btn"
                (click)="onResetEvaClicked()">Reset
                Eva</button>
        </div>
    </div>
</div>